<div class="flex w-full flex-col gap-1">
  <div
    class="flex min-h-(--ig-editor-textarea-min-height,6rem) w-full items-stretch overflow-hidden rounded-(--ig-editor-field-radius,6px) border border-(--ig-editor-field-border-color,transparent) bg-(--ig-editor-field-bg,#2b2e32) text-sm transition-[border-color,box-shadow] duration-150 focus-within:border-(--ig-editor-focus-border-color,var(--ig-editor-field-border-color,transparent)) focus-within:shadow-[0_0_0_3px_var(--ig-editor-focus-shadow,transparent)]">
    <textarea
      class="min-w-0 flex-1 m-0 resize-y border-0 bg-transparent py-2 px-2 text-sm leading-normal text-(--ig-editor-text-color,#ffffff) placeholder:opacity-45 focus:outline-none"
      [class.font-mono]="mono()"
      [id]="inputId()"
      [rows]="rows()"
      [value]="value() ?? ''"
      [placeholder]="placeholder()"
      (input)="applyValue($event)"></textarea>
  </div>
</div>
